module.exports = __webpack_public_path__ + "img/tuxiang84.2d17fd95.png";